import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { sleep } from 'common';

@Component({
  selector: 'tyt-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit {

  constructor() { }

  async ngOnInit() {
    await sleep(1);
    this.animateIn = true;
  }

  @HostBinding('class.animate-in')
  animateIn = false;

  @Input()
  allowHideSidebar = false;
  
  showSidebar = true;

  hideSidebar() {
    this.showSidebar = false;
  }
}
